import * as moment from 'moment'

const autocastsReportModule = {
  namespaced: true,

  state: {
    loading: false,
    allAutocasts: [],
    allAutocastsInfo: [],
    period: { start: null, end: null },
    ordersSum: 0,
    pagination: { perPage: 10, page: 0 }
  },

  mutations: {
    setAllMessages: (state, allAutocasts) => (state.allAutocasts = allAutocasts),
    setMessagesInfo: (state, allAutocastsInfo) => (state.allAutocastsInfo = allAutocastsInfo),
    setLoading: (state, loading) => (state.loading = loading),
    setPeriod: (state, period) => (state.period = JSON.parse(JSON.stringify(period))),
    setOrdersSum: (state, orders_sum) => (state.ordersSum = orders_sum),
    setPagination: (state, pagination) => (state.pagination = pagination)
  },

  getters: {
    getAll: (state) => (period) => {
      if (!state.allAutocasts.length) return state.allAutocasts
      if (!period) return state.allAutocasts

      return state.allAutocasts.filter(
        (ac) =>
          new Date(ac.time_added).getTime() >= new Date(period.start).getTime() &&
          new Date(ac.time_added).getTime() <= new Date(period.end).getTime()
      )
    },

    getAllIds: (_, getters) => (period) => {
      if (!getters.getAll(period).length) return null

      return getters.getAll(period).reduce((acc, item) => {
        if (!item.cases.length) {
          acc.push(item.message)
        } else {
          item.cases.forEach((c) => {
            acc.push(c.message)
          })
        }

        return acc
      }, [])
    },

    getData: (state, getters) => {
      return getters.getAll(state.period).reduce((acc, item) => {
        const messageInfo = {}

        const info = state.allAutocastsInfo.find((info) => info.id === item.message)

        if (!info) return acc

        messageInfo.name = info.name
        messageInfo.count = info.email_stats[0].count
        messageInfo.delivered = info.email_stats[0].delivered
        messageInfo.opened = info.email_stats[0].opened
        messageInfo.clicked = info.email_stats[0].clicked
        messageInfo.sent = moment(info.sent).format('DD.MM.YYYY HH:mm:ss')
        messageInfo.id = info.id
        messageInfo.orders_count = info.orders_count
        messageInfo.opened_percent = info.email_stats[0].opened_percent
        messageInfo.unsubscribed_percent = info.email_stats[0].unsubscribed_percent
        messageInfo.clicked_percent = info.email_stats[0].clicked_percent
        messageInfo.case = []

        if (item.cases.length) {
          item.cases.forEach((c) => {
            const infoCase = state.allAutocastsInfo.find((infoCase) => infoCase.id === c.message)
            if (infoCase && infoCase.id !== info.id) {
              messageInfo.case.push({
                name: infoCase.name,
                count: infoCase.email_stats[0].count,
                delivered: infoCase.email_stats[0].delivered,
                opened: infoCase.email_stats[0].opened,
                clicked: infoCase.email_stats[0].clicked,
                sent: moment(infoCase.sent).format('DD.MM.YYYY HH:mm:ss'),
                id: infoCase.id,
                orders_count: infoCase.orders_count,
                opened_percent: infoCase.email_stats[0].opened_percent,
                unsubscribed_percent: infoCase.email_stats[0].unsubscribed_percent,
                clicked_percent: infoCase.email_stats[0].clicked_percent
              })
            }
          })
        }

        acc.push(messageInfo)

        return acc
      }, [])
    }
  }
}

export default autocastsReportModule



// WEBPACK FOOTER //
// ./src/store/modules/reports/modules/emails/modules/autocasts.js